import LinearProgress from '@mui/material/LinearProgress'
import { styled } from '@mui/material/styles'

const LoadingRoot = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(1),
}))

const LoadingLinear = () => {
  return (
    <LoadingRoot>
      <LinearProgress />
    </LoadingRoot>
  )
}

export { LoadingLinear }
